import { useMutation } from '@tanstack/react-query';
import { updateStoreSettings } from '@/lib/api/settings';
import { stanNotify } from '@/lib/stanNotify';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useCurrencyMutation = () => {
    return useMutation({
        mutationFn: (currency: string) => updateStoreSettings({ currency }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
            stanNotify({
                type: 'success',
                title: 'Success!',
                text: 'Currency has been saved.',
            });
        },
        onError: (error: any) => {
            stanNotify({
                type: 'error',
                title: 'Something went wrong',
                text: error?.response?.data?.message || 'Please try again later.',
            });
        },
    });
};
